import { api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngine } from '@/init/swagger';
import yup from '@/init/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { InferType } from 'yup';

export type IsCalendarOrCondition = Exclude<
  api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngine['is_calendar_or'],
  undefined
>;

export const SearchStationCalendarSchema = yup.object({
  is_calendar_or_condition: yup.number<IsCalendarOrCondition>(),
  calendar_conditions: yup.array(
    yup.object({
      is_sunday: yup.boolean(),
      is_monday: yup.boolean(),
      is_tuesday: yup.boolean(),
      is_wednesday: yup.boolean(),
      is_thursday: yup.boolean(),
      is_friday: yup.boolean(),
      is_saturday: yup.boolean(),
      zone_start: yup.string(),
      zone_end: yup.string(),
    }),
  ),
  date_start_condition: yup.string(),
  date_end_condition: yup.string(),
});

export type SearchStationCalendarType = InferType<
  typeof SearchStationCalendarSchema
>;
export const SearchStationCalendarResolver = yupResolver(
  SearchStationCalendarSchema,
);
